<div class="sub-menu-navbar-container">
  @for (link of links; track link; let i = $index) {
    <a class="sub-menu-navbar-item item-{{i}}"
      [routerLink]="generateLinkPath(link.path)"
      routerLinkActive="active"
      title="{{ link.data!.titleKey | translate: translationGroup }}">
      <span>{{ link.data!.titleKey | translate: translationGroup }}</span>
      @if (link.data?.count) {
        <span
        class="badge badge-pill me-2">&nbsp;{{link.data!.count}}&nbsp;</span>
      }
    </a>
  }
  @if ((showButton && buttonTitle) || (showSecondButton && secondButtonTitle)) {
    <div
      class="sub-menu-navbar-button item-5">
      @if (showButton && buttonTitle) {
        <button type="button"
          class="eshava-btn eshava-btn-primary"
        (click)="onButtonClicked()">{{buttonTitle}}</button>
      }
      @if (showSecondButton && secondButtonTitle) {
        <button type="button"
          class="eshava-btn eshava-btn-primary ms-2"
        (click)="onSecondButtonClicked()">{{secondButtonTitle}}</button>
      }
    </div>
  }
</div>